import Facebook from './Svg/Facebook';
import LinkedIn from './Svg/LinkedIn';
import Twitter from './Svg/Twitter';

const SocialShare = ({ platform, url, fill }) => {
    let href;
    let icon;

    switch (platform) {
        case 'facebook':
            href = 'https://www.facebook.com/sharer.php?u=';
            icon = <Facebook fill={fill} />;
            break;
        case 'twitter':
            href = 'https://twitter.com/intent/tweet?url=';
            icon = <Twitter {...{ fill }} />;
            break;
        case 'linkedin':
            href = 'https://www.linkedin.com/sharing/share-offsite/?url=';
            icon = <LinkedIn {...{ fill }} />;
            break;
    }

    const handleClick = () => {
        const left = (screen.width - 570) / 2;
        const top = (screen.height - 570) / 2;
        const params =
            'menubar=no,toolbar=no,status=no,width=570,height=570,top=' +
            top +
            ',left=' +
            left;
        window.open(href + url, 'NewWindow', params);
    };

    return <a onClick={handleClick}>{icon}</a>;
};

export default SocialShare;
